import { render, staticRenderFns } from "./McompatibilidadModals.vue?vue&type=template&id=612b0376"
import script from "./McompatibilidadModals.vue?vue&type=script&lang=js"
export * from "./McompatibilidadModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports